import { render } from "./LabPaidCredit3Payment.vue?vue&type=template&id=eb5c345c"
import script from "./LabPaidCredit3Payment.vue?vue&type=script&lang=js"
export * from "./LabPaidCredit3Payment.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\mlab\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__